import { Component } from '@angular/core';
import { IonicPage, ModalController, Platform } from 'ionic-angular';
import * as moment from 'moment';
import { QrGeneratorModalPage } from '../qr-generator-modal/qr-generator-modal';
import { SubscriptionsService } from '../../services/subscriptions/subscriptions-service';
import { CustomersService } from '../../services/customers/customers-service';
import { Customer } from '../../models/customer';
import { ENV } from '../../environments/environment';

@IonicPage()
@Component({
  selector: 'page-customer-overview',
  templateUrl: 'customer-overview.html',
})
export class CustomerOverviewPage {
  public Customer: Customer;
  public today: string;
  public qrCodeFilename: string;
  private planLabel: string;
  public isCordova: boolean;
  public invoices: any;
  public events: any;
  public statusDate: string;

  setup() {

    // format dates & check for birthday.
    this.today = (moment()).format("YYYY-MM-DD");
    this.statusDate = (moment(this.Customer.get("meta").status_date)).format("MM/DD/YYYY");

    // set Qr Code Filename
    this.setQrFilename();

    // set Subscription Plan name.
    this.planLabel = this.Customer.get("meta").name;

    // fetch Subscription Histories.
    this.fetchInvoices();
    this.fetchEvents();
  }

  setQrFilename() {
    this.qrCodeFilename = [this.Customer.get("meta").contact_id, this.Customer.get("meta").subscription_id, this.Customer.get("meta").hash, "svg"].join(".");
  }

  fetchInvoices() {
    try {
      this.subscriptionService.getInvoices(this.Customer.get("meta").contact_id)
        .subscribe(res => this.invoices = res.map(function(r){
            r.Invoice_Date = ((moment(r.Invoice_Date)).isValid() ? (moment(r.Invoice_Date)).format("MM/DD/YYYY") : r.Invoice_Date);
            return r;
          })
        );
    }
    catch(ex) {
      console.log("Failed to display customer invoices. ",ex);
    }
  }

  fetchEvents() {
    try {
      this.subscriptionService.getEvents(this.Customer.get("meta").contact_id)
        .subscribe(res => this.events = res.map(function(r){
            r.Start_DateTime = ((moment(r.Start_DateTime)).isValid() ? (moment(r.Start_DateTime)).format("MM/DD/YYYY") : r.Start_DateTime);
            return r;
          })
        );
    }
    catch(ex) {
      console.log("Failed to display customer events. ",ex);
    }
  }

  regenerate() {
    let qrGeneratorModal = this.modalCtrl.create(QrGeneratorModalPage, {
      contact_id: this.Customer.get("meta").contact_id,
      subscription_id: this.Customer.get("meta").subscription_id,
      hash: this.Customer.get("meta").hash
    });

    qrGeneratorModal.onDidDismiss(res => {
      if(res && res.hash != false)
      {
        this.Customer.get("meta").hash = res.hash;
      }
    });

    qrGeneratorModal.present();
  }

  print() {
    if(!this.qrCodeFilename){ return; }

    this.setQrFilename();

    let qrDom: string;

    qrDom = "<html style='margin:0px;margin-top:99px;padding:0px;width:210px;height:190px;overflow:hidden;'>"
          +   "<body style='padding:0px;height:190px;'>"
          +		"<div style='height: 30px;text-align:center;'>"
		  +		  "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' "
		  +		  	"width='180px' height='29.5px' viewBox='0 0 180 29.5' enable-background='new 0 0 180 29.5' xml:space='preserve'>"
		  +		  "<g>"
		  +		  	"<path fill='#010101' d='M1.736,3.938c0-0.856,0.898-1.24,1.796-1.24h9.023c0.855,0,1.197,0.897,1.197,1.752"
		  +		  		"c0,0.984-0.427,1.796-1.197,1.796H5.799v4.405h3.934c0.77,0,1.197,0.77,1.197,1.583c0,0.684-0.385,1.539-1.197,1.539H5.799v6.713"
		  +		  		"c0,0.855-1.027,1.24-2.01,1.24c-0.984,0-2.011-0.428-2.011-1.24V3.938H1.736z M23.117,14.244v6.2c0,0.685-0.855,1.24-1.967,1.24"
		  +		  		"c-1.027,0-1.796-0.556-1.796-1.24v-0.555c-0.941,1.068-2.137,2.095-3.934,2.095c-1.796,0-3.335-1.07-3.335-3.465"
		  +		  		"c0-3.079,2.48-3.933,6.072-3.933h0.941v-0.257c0-0.898-0.471-1.925-1.968-1.925c-2.138,0-2.352,0.855-3.036,0.855"
		  +		  		"c-0.898,0-1.369-1.069-1.369-2.009c0-1.197,2.523-2.095,4.447-2.095C21.45,9.155,23.117,11.635,23.117,14.244z M19.098,16.509"
		  +		  		"H18.97c-1.497,0-2.865,0.128-2.865,1.412c0,0.77,0.428,1.069,1.026,1.069c0.812,0,1.968-1.069,1.968-2.395V16.509L19.098,16.509z"
		  +		  		" M32.781,14.628c0-1.326-0.897-1.968-1.795-1.968c-0.855,0-1.625,0.599-1.625,1.968v5.815c0,0.599-0.94,1.24-2.01,1.24"
		  +		  		"c-1.154,0-2.01-0.599-2.01-1.24v-9.921c0-0.727,0.856-1.197,2.01-1.197c0.983,0,1.796,0.513,1.796,1.197v0.599"
		  +		  		"c0.556-1.026,1.711-1.967,3.421-1.967c1.411,0,2.565,1.069,3.079,2.609c0.898-1.796,2.437-2.609,3.892-2.609"
		  +		  		"c2.437,0,4.746,1.967,4.746,5.474v5.815c0,0.599-0.897,1.24-2.009,1.24c-1.07,0-2.01-0.599-2.01-1.24v-5.815"
		  +		  		"c0-1.326-0.855-1.968-1.753-1.968c-0.855,0-1.667,0.642-1.667,1.968v5.858c0,0.855-1.027,1.198-2.01,1.198"
		  +		  		"c-0.941,0-2.01-0.385-2.01-1.198L32.781,14.628L32.781,14.628z M50.614,5.049c0,0.983-0.941,1.882-2.095,1.882"
		  +		  		"c-1.198,0-2.139-0.899-2.139-1.882c0-0.984,0.941-1.839,2.139-1.839C49.673,3.21,50.614,4.023,50.614,5.049z M50.528,10.523v9.921"
		  +		  		"c0,0.599-0.898,1.24-2.009,1.24c-1.156,0-2.011-0.599-2.011-1.24v-9.921c0-0.727,0.855-1.197,2.011-1.197"
		  +		  		"C49.63,9.326,50.528,9.796,50.528,10.523z M57.114,3.467v17.02c0,0.599-0.898,1.24-2.011,1.24c-1.154,0-2.01-0.598-2.01-1.24V3.467"
		  +		  		"c0-0.727,0.855-1.197,2.01-1.197C56.216,2.227,57.114,2.74,57.114,3.467z M58.696,11.593c-0.085-0.128-0.128-0.343-0.128-0.514"
		  +		  		"c0-1.026,1.668-1.924,2.737-1.924c0.513,0,0.941,0.171,1.112,0.641l2.951,7.056l2.138-7.056c0.171-0.47,0.599-0.641,1.026-0.641"
		  +		  		"c0.941,0,2.78,0.898,2.78,2.01c0,0.129-0.042,0.342-0.085,0.428l-3.72,9.236c-1.326,3.292-1.839,6.542-7.141,6.542"
		  +		  		"c-1.027,0-1.838-0.171-1.838-1.71c0-0.898,0.256-1.668,0.983-1.668c0.94,0,3.72-0.043,3.72-3.335L58.696,11.593L58.696,11.593z'/>"
		  +		  	"<path fill='#010101' d='M84.225,6.204c-1.497,0-2.352,0.855-2.352,2.608v6.885c0,1.796,0.855,2.609,2.352,2.609"
		  +		  		"c2.095,0,2.224-1.583,2.31-2.609c0.085-0.983,0.983-1.197,2.009-1.197c1.411,0,2.053,0.385,2.053,1.924"
		  +		  		"c0,3.465-2.823,5.431-6.543,5.431c-3.421,0-6.243-1.668-6.243-6.158V8.812c0-4.489,2.822-6.157,6.243-6.157"
		  +		  		"c3.721,0,6.543,1.881,6.543,5.174c0,1.54-0.642,1.924-2.011,1.924c-1.068,0-1.966-0.299-2.01-1.197"
		  +		  		"C86.535,7.872,86.449,6.204,84.225,6.204z M102.785,14.244v6.2c0,0.685-0.856,1.24-1.967,1.24c-1.026,0-1.797-0.556-1.797-1.24"
		  +		  		"v-0.555c-0.94,1.068-2.138,2.095-3.934,2.095c-1.795,0-3.335-1.07-3.335-3.465c0-3.079,2.48-3.933,6.072-3.933h0.94v-0.257"
		  +		  		"c0-0.898-0.47-1.925-1.967-1.925c-2.138,0-2.352,0.855-3.036,0.855c-0.898,0-1.368-1.069-1.368-2.009"
		  +		  		"c0-1.197,2.522-2.095,4.447-2.095c4.318,0,5.943,2.48,5.943,5.089H102.785z M98.764,16.509h-0.085"
		  +		  		"c-1.497,0-2.865,0.128-2.865,1.412c0,0.77,0.427,1.069,1.026,1.069c0.812,0,1.967-1.069,1.967-2.395v-0.086H98.764z"
		  +		  		" M111.935,12.661c-1.454,0-2.822,1.498-2.822,3.892v3.892c0,0.599-0.898,1.24-2.053,1.24s-1.967-0.599-1.967-1.24v-9.921"
		  +		  		"c0-0.727,0.855-1.197,1.967-1.197c0.984,0,1.797,0.513,1.797,1.197v0.983c0.512-1.154,1.795-2.352,3.078-2.352h0.77"
		  +		  		"c0.77,0,1.454,0.812,1.454,1.753c0,0.983-0.684,1.796-1.454,1.796L111.935,12.661L111.935,12.661z M137.978,20.486"
		  +		  		"c-0.343,0.898-1.497,1.369-2.651,1.369c-1.155,0-2.437-0.428-2.608-1.369l-1.369-6.157l-1.369,6.157"
		  +		  		"c-0.214,0.898-1.454,1.369-2.609,1.369c-1.197,0-2.394-0.428-2.651-1.369l-5.174-15.864c-0.043-0.086-0.043-0.214-0.043-0.342"
		  +		  		"c0-0.898,1.454-1.625,2.608-1.625c0.599,0,1.155,0.214,1.326,0.77l3.934,13.342l2.053-8.81c0.128-0.684,1.069-1.069,1.967-1.069"
		  +		  		"c0.898,0,1.796,0.385,1.967,1.069l2.053,8.81l3.934-13.342c0.127-0.556,0.684-0.77,1.325-0.77c1.154,0,2.609,0.727,2.609,1.625"
		  +		  		"c0,0.128-0.043,0.256-0.043,0.342L137.978,20.486L137.978,20.486z M153.628,14.244v6.2c0,0.685-0.855,1.24-1.967,1.24"
		  +		  		"c-1.026,0-1.796-0.556-1.796-1.24v-0.555c-0.94,1.068-2.138,2.095-3.934,2.095c-1.796,0-3.336-1.07-3.336-3.465"
		  +		  		"c0-3.079,2.48-3.933,6.073-3.933h0.94v-0.257c0-0.898-0.47-1.925-1.966-1.925c-2.139,0-2.353,0.855-3.036,0.855"
		  +		  		"c-0.899,0-1.37-1.069-1.37-2.009c0-1.197,2.523-2.095,4.448-2.095C152.004,9.155,153.628,11.635,153.628,14.244L153.628,14.244z"
		  +		  		" M149.608,16.509h-0.085c-1.496,0-2.865,0.128-2.865,1.412c0,0.77,0.428,1.069,1.026,1.069c0.812,0,1.967-1.069,1.967-2.395v-0.086"
		  +		  		"H149.608z M161.71,18.092c0-1.796-6.072-0.556-6.072-4.961c0-1.924,1.198-4.02,4.875-4.02c2.266,0,4.404,0.77,4.404,1.882"
		  +		  		"c0,0.512-0.514,1.924-1.454,1.924c-0.684,0-1.497-0.77-2.908-0.77c-1.025,0-1.496,0.427-1.496,0.855"
		  +		  		"c0,1.454,6.158,0.385,6.158,4.96c0,2.438-1.796,4.021-5.003,4.021c-2.737,0-4.961-1.113-4.961-2.395"
		  +		  		"c0-0.599,0.514-1.796,1.326-1.796c0.854,0,1.454,1.155,3.506,1.155C161.454,18.99,161.71,18.477,161.71,18.092z M171.119,20.444"
		  +		  		"c0,0.599-0.941,1.24-2.01,1.24c-1.154,0-2.01-0.599-2.01-1.24V3.467c0-0.727,0.856-1.197,2.01-1.197c1.068,0,2.01,0.514,2.01,1.197"
		  +		  		"v7.698c0.47-1.027,1.625-1.967,3.25-1.967c2.352,0,4.404,2.481,4.404,5.474v5.815c0,0.855-1.026,1.24-2.01,1.24"
		  +		  		"c-0.94,0-2.009-0.428-2.009-1.24v-5.858c0-0.983-0.856-1.968-1.881-1.968c-0.856,0-1.753,0.728-1.753,1.968V20.444L171.119,20.444z"
		  +		  		"'/>"
		  +		  "</g>"
		  +		  "</svg>"
          +		"</div>"
          +     "<div style='margin:0px;margin-left:6px;padding:0px;overflow:hidden;width:180px;height:175px;'>"
          +       `<img src='${ENV.apiUrl}/qr-codes/${this.qrCodeFilename.replace(".svg",".md.svg")}' `
          +       "style='width:220px;height:220px;margin:0px;margin-left:-20px;margin-top:-20px;padding:0px;' />"
          +     "</div>"
          +   "</body>"
          +  "</html>";

    var printWindow = window.open('', 'Family Car Wash | Subscription QR Code','height=300,width=300');
    printWindow.document.write(qrDom);
    printWindow.document.close();
    printWindow.onload = function() { printWindow.print(); };
  }

  constructor(private subscriptionService: SubscriptionsService,
    private platform: Platform,
    public modalCtrl: ModalController,
    private custService: CustomersService) {

      // Identify if this is browser or device.
      this.isCordova = this.platform.is('cordova');

      this.Customer = this.custService.get();

      this.setup();
  }
}



// WEBPACK FOOTER //
// ./src/pages/customer-overview/customer-overview.ts